if (!customElements.get('bb-fabric-carousel')) {
  customElements.define('bb-fabric-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.rail = this.querySelector('[data-fabric-rail]');
      this.controls = this.querySelector('[data-fabric-controls]');
      this.motion = this.querySelector('[data-fabric-motion]');
      this.previous = this.querySelector('[data-fabric-prev]');
      this.next = this.querySelector('[data-fabric-next]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.direction = 1;
      this.sign = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
      this.motion.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, options);
      this.previous.addEventListener('click', () => this.step(-1), options);
      this.next.addEventListener('click', () => this.step(1), options);
      this.rail.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      for (const event of ['pointerdown', 'wheel', 'keydown']) {
        this.rail.addEventListener(event, () => { this.paused = true; this.update(); }, { ...options, passive: true });
      }
      this.addEventListener('pointerenter', () => { this.hovered = true; this.update(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.update(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.update(); }, options);
      this.reduced.addEventListener('change', () => { this.paused = this.reduced.matches; this.update(); }, options);
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.rail);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); });
      this.observer.observe(this);
      this.update();
    }

    updateControls() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const position = Math.abs(this.rail.scrollLeft);
      this.controls.hidden = max <= 1;
      this.previous.disabled = position <= 1;
      this.next.disabled = position >= max - 1;
    }

    update() {
      cancelAnimationFrame(this.frame);
      this.lastTime = null;
      this.updateControls();
      this.motion.textContent = this.paused ? this.motion.dataset.playLabel : this.motion.dataset.pauseLabel;
      if (!this.controls.hidden && !this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) {
        this.frame = requestAnimationFrame(time => this.tick(time));
      }
    }

    tick(time) {
      const delta = this.lastTime === null ? 0 : Math.min(time - this.lastTime, 50);
      this.lastTime = time;
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const position = Math.abs(this.rail.scrollLeft);
      if (position >= max - 1) this.direction = -1;
      else if (position <= 1) this.direction = 1;
      this.rail.scrollLeft = this.sign * Math.max(0, Math.min(max, position + this.direction * delta * .018));
      this.frame = requestAnimationFrame(next => this.tick(next));
    }

    step(direction) {
      this.paused = true;
      this.update();
      this.rail.scrollBy({ left: this.sign * direction * this.rail.clientWidth * .8, behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.abort = null;
    }
  });
}
